
define('modules/application/calculationClasses/audioVideo',[
    "app",

    // Libs
    "backbone"
  ],

  function(app, Backbone) {

    var CalculationClass = {};

    CalculationClass.resetValues = function() {
      //Resetting values
      BticinoS4B.solution.audioVideo.externalItems = [];
      BticinoS4B.solution.audioVideo.zonesItems = [];
      BticinoS4B.solution.audioVideo.internals = [];
      BticinoS4B.Instances.Models.ApplicationModel.set("externalItems", []);
      BticinoS4B.Instances.Models.ApplicationModel.set("zonesItems", []);
      BticinoS4B.Instances.Models.ApplicationModel.set("internals", []);
    };

    CalculationClass.startAutomaticCalculation = function() {
      CalculationClass.resetValues();

      //Requesting model delivery
      window.BticinoS4B.eventAggregator.trigger("modelDeliver:request", this);

      var automaticCalculationModel = {
        externalItems: [],
        zones: []
      };
      var powerSupply, vdeExpansion, busExpansion, apartmentInterface, radioSystems, zone, interfacesToOptimize = [],
        optimizedInterfaces = [];
      var k = 1,
        l = 0,
        i = 0,
        j = 0,
        m = 0;

      if (!automaticCalculationModel.automaticItems) {
        automaticCalculationModel.automaticItems = [];
      }

      //Interfaces optimization
      optimizedInterfaces = automaticCalculationModel.automaticItems;

      var dataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider");
      dataProvider.addItems("automaticItems", optimizedInterfaces);

      automaticCalculationModel.automaticItems = this.requestAutomaticProducts();
      dataProvider.addItems("automaticItems", automaticCalculationModel.automaticItems);
      this.set("automaticCalculationModel", automaticCalculationModel);
      BticinoS4B.solution.audioVideo.automaticProducts = _.extend({}, this.get("automaticCalculationModel"));
      BticinoS4B.Instances.Models.ApplicationModel.set("automaticProducts", BticinoS4B.solution.audioVideo.automaticProducts);
      this.createConfiguration();
    };

    CalculationClass.requestAutomaticProducts = function() {
      var automaticProducts = [];

      //Calculating needed line terminators
      automaticProducts.push(this.calculateLineTerminators());

      //Calculating automatic items
      automaticProducts.push(this.calculateVdeExpansion());

      //Requesting a NEEDED current deliver
      window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
      //console.log(BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel").get("totalConsumptionInmA"), "before");
      automaticProducts.push(this.calculateBusExpansion());

      //calculating automatic floor shunts
      automaticProducts.push(this.calcuateFloorShunts());

      //Calculating needed power supplies based on the worst case of currentConsumption
      window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
      //console.log(BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel").get("totalConsumptionInmA"), "after");
      automaticProducts.push(this.calculatePowerSupplies());

      return _.flatten(automaticProducts);
    };

    CalculationClass.calculateVdeExpansion = function() {
      var sources = BticinoS4B.solution.audioVideo.sources ? BticinoS4B.solution.audioVideo.sources.get("collection").length : 0,
        apartmentInterface = BticinoS4B.solution.audioVideo.apartmentInterfaceItems ? BticinoS4B.solution.audioVideo.apartmentInterfaceItems.length : 0,
        vdes = BticinoS4B.solution.audioVideo.vdes ? BticinoS4B.solution.audioVideo.vdes.get("collection").length : 0,
        choosenDistributionSystem = BticinoS4B.Instances.Models.ApplicationModel.get('choosenDistributionSystem'),
        numberOfVdeExpsToAdd = 0,
        vdeExpsToAdd = [],
        packageToAdd;

      if (vdes > 1) {

        //Retrieve vde expansion package
        BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(6421, function(data) {
          data.specialVars = JSON.parse(data.specialVars);
          packageToAdd = data;

          BticinoS4B.Instances.Models.ApplicationModel.getProducts(6421, function(data) {
            var mainProduct = _.filter(data.products, function(iterableProduct) {
                return iterableProduct.mnemonic === 1;
              })[0],
              secondaryProducts = _.filter(data.products, function(iterableProduct) {
                return iterableProduct.mnemonic !== 1;
              });
            _.extend(packageToAdd, mainProduct);

            packageToAdd.secondaryProducts = secondaryProducts;
            packageToAdd.attachedProducts = [];
            packageToAdd.quantity = 1;
          });
        });
        
        //NUOVO CALCOLO DELLE ESPANSIONI 2014/06/27
        //Calculating number of expansionToAdd
        if (choosenDistributionSystem.packageClassId == '6602') {
          //nodo audio video
          numberOfVdeExpsToAdd = Math.floor((sources + apartmentInterface + vdes - 2) / 3);
          }
        else if (choosenDistributionSystem.packageClassId == '6605') {
          // matrice
          numberOfVdeExpsToAdd = Math.floor((apartmentInterface + vdes - 2) / 3);
          }
        //6601 non è possibile aggiugnere un espansione

        for (var i = numberOfVdeExpsToAdd - 1; i >= 0; i--) {
          vdeExpsToAdd.push(packageToAdd);
          if (packageToAdd.secondaryProducts)
            for (var j = 0; j < packageToAdd.secondaryProducts.length; j++) {
              packageToAdd.secondaryProducts[j].quantity = packageToAdd.quantity;
              vdeExpsToAdd.push(packageToAdd.secondaryProducts[j]);
            }
        }
      }

      return vdeExpsToAdd;
    };

    CalculationClass.calculateBusExpansion = function() {
      var busExpansions = [],
        i = 0;

      //Calcualating overConsumption zones
      var zones = _.filter(BticinoS4B.solution.audioVideo.zones.collection.models, function(iterableZone) {
        return iterableZone.get("number") >= 1;
      });

      //This method retrieve total zone consumption
      var calculateZoneConsumption = function(zone) {
        var zoneConsumption = 0,
          amplifierAndLoudSpeakersCollection = zone.get("amplifierAndLoudSpeakersModel").get("collection").models;

        for (var i = amplifierAndLoudSpeakersCollection.length - 1; i >= 0; i--) {
          zoneConsumption += amplifierAndLoudSpeakersCollection[i].get("specialVars").currentConsumption;

          if (amplifierAndLoudSpeakersCollection[i].get("specialVars").busAmplifier)
            zoneConsumption += amplifierAndLoudSpeakersCollection[i].get("accessory").specialVars.currentConsumption * amplifierAndLoudSpeakersCollection[i].get("accessoryValue");
        }

        if (zoneConsumption > 600)
          zone.get("amplifierAndLoudSpeakersModel").set("overload", true);
        else
          zone.get("amplifierAndLoudSpeakersModel").set("overload", false);

        return zoneConsumption;
      };

      //This method add needed busExpansions
      var retrieveBusExpansion = function(zone) {
        var packageToAdd,
          packagesToAdd = [],
          i = 0;

        //Recupero pacchetto "Espansione di 2 tratte isolate video" e lo aggiungo
        BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(6441, function(data) {
          packageToAdd = data;
          packageToAdd.specialVars = JSON.parse(packageToAdd.specialVars);

          BticinoS4B.Instances.Models.ApplicationModel.getProducts(6441, function(productsData) {
            _.extend(packageToAdd, _.filter(productsData.products, function(iterableProduct) {
              return iterableProduct.mnemonic === 1;
            })[0]);
            packageToAdd.secondaryProducts = _.filter(productsData.products, function(iterableProduct) {
              return iterableProduct.mnemonic !== 1;
            });
            if (zone)
              packageToAdd.specialVars.currentConsumption = 0;
          });
        });

        packageToAdd.quantity = 1;
        packagesToAdd.push(packageToAdd);


        //Recupero pacchetto "Alimentatore 346030 (600 mA) compatto" e lo aggiungo

        //MODIFICATO RETRIEVE ALIMENTNTATORE da 6603 a 6604 (da normale a compatto)
        //in seguito a segnalazione Mantis 05281: Calcolo automatico espansioni
        BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(6604, function(data) {
          packageToAdd = data;
          packageToAdd.specialVars = JSON.parse(packageToAdd.specialVars);

          BticinoS4B.Instances.Models.ApplicationModel.getProducts(6604, function(productsData) {
            _.extend(packageToAdd, _.filter(productsData.products, function(iterableProduct) {
              return iterableProduct.mnemonic === 1;
            })[0]);
            packageToAdd.secondaryProducts = _.filter(productsData.products, function(iterableProduct) {
              return iterableProduct.mnemonic !== 1;
            });
            if (zone)
              packageToAdd.specialVars.currentConsumption = 0;
          });
        });

        packageToAdd.quantity = 1;
        packagesToAdd.push(packageToAdd);

        return packagesToAdd;
      };

      //Check which zone is out of consumption
      for (i = zones.length - 1; i >= 0; i--) {
        if (calculateZoneConsumption(zones[i]) > 600)
          busExpansions.push(retrieveBusExpansion(zones[i]));
      }

      //Calculate necessity of busExpansions
      var handsetsLength = BticinoS4B.solution.audioVideo.handsets ? BticinoS4B.solution.audioVideo.handsets.get("collection").length : 0,
        neededBusExpansions = (handsetsLength > 0) ? ((handsetsLength <= 5) ? 0 : Math.ceil(handsetsLength / 5) - 1) : 0,

        busExpansionsLength = busExpansions.length,
        consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");

      for (i = neededBusExpansions; i > busExpansionsLength; i--)
        busExpansions.push(retrieveBusExpansion());

      busExpansions = _.flatten(busExpansions);

      for (i = busExpansions.length - 1; i >= 0; i--) {
        if (busExpansions[i].specialVars.currentConsumption < 0) {
          consumptionIndicatorModel.addConversationSupplyCurrent(busExpansions[i].specialVars.currentConsumption);
          consumptionIndicatorModel.addSoundDiffusionSupplyCurrent(busExpansions[i].specialVars.currentConsumption);
        } else {
          consumptionIndicatorModel.addConversationCurrentConsumption(busExpansions[i].specialVars.currentConsumption);
          consumptionIndicatorModel.addSoundDiffusionCurrentConsumption(busExpansions[i].specialVars.currentConsumption);
        }

        for (j = 0; j < busExpansions[i].secondaryProducts.length; j++) {
          busExpansions.push(_.extend(_.extend({}, busExpansions[i]), busExpansions[i].secondaryProducts[j]));
        }
      }

      return busExpansions;
    };

    CalculationClass.calculatePowerSupplies = function() {

      //Functions
      var retrievePackageConsumption = function(memo, packageToAnalyze) {
        return memo + packageToAnalyze.specialVars.currentConsumption;
      };

      var retrieveSmallPowerSupplyPackage = function() {
        var packageToAdd;

        BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(6604, function(data) {
          packageToAdd = data;
          packageToAdd.specialVars = JSON.parse(packageToAdd.specialVars);

          BticinoS4B.Instances.Models.ApplicationModel.getProducts(6604, function(data) {
            _.extend(packageToAdd, _.filter(data.products, function(iterableProduct) {
              return iterableProduct.mnemonic === 1;
            })[0]);
            packageToAdd.secondaryProducts = _.filter(data.products, function(iterableProduct) {
              return iterableProduct.mnemonic !== 1;
            });
          });
        });

        packageToAdd.quantity = 1;

        return packageToAdd;
      };

      var retrieveStandardPowerSupplyPackage = function() {
        var packageToAdd;

        BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(6603, function(data) {
          packageToAdd = data;
          packageToAdd.specialVars = JSON.parse(packageToAdd.specialVars);

          BticinoS4B.Instances.Models.ApplicationModel.getProducts(6603, function(data) {
            _.extend(packageToAdd, _.filter(data.products, function(iterableProduct) {
              return iterableProduct.mnemonic === 1;
            })[0]);
            packageToAdd.secondaryProducts = _.filter(data.products, function(iterableProduct) {
              return iterableProduct.mnemonic !== 1;
            });
          });

        });

        packageToAdd.quantity = 1;
        return packageToAdd;
      };

      var retrieveBusExpansionPackage = function(zone) {
        var packageToAdd,
          packagesToAdd = [];

        BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(6441, function(data) {
          packageToAdd = data;
          packageToAdd.specialVars = JSON.parse(packageToAdd.specialVars);

          BticinoS4B.Instances.Models.ApplicationModel.getProducts(6441, function(data) {
            _.extend(packageToAdd, _.filter(data.products, function(iterableProduct) {
              return iterableProduct.mnemonic === 1;
            })[0]);
            packageToAdd.secondaryProducts = _.filter(data.products, function(iterableProduct) {
              return iterableProduct.mnemonic !== 1;
            });
          });

        });

        packageToAdd.quantity = 1;
        packagesToAdd.push(packageToAdd);

        BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(6603, function(data) {
          packageToAdd = data;
          packageToAdd.specialVars = JSON.parse(packageToAdd.specialVars);

          BticinoS4B.Instances.Models.ApplicationModel.getProducts(6603, function(data) {
            _.extend(packageToAdd, _.filter(data.products, function(iterableProduct) {
              return iterableProduct.mnemonic === 1;
            })[0]);
            packageToAdd.secondaryProducts = _.filter(data.products, function(iterableProduct) {
              return iterableProduct.mnemonic !== 1;
            });
            if (zone)
              packageToAdd.specialVars.currentConsumption = 0;
          });

        });

        packageToAdd.quantity = 1;
        packagesToAdd.push(packageToAdd);

        return packagesToAdd;
      };

      //Variables
      var totalCurrentConsumption = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel").get("totalConsumptionInmA"),
        smallPowerSupply = retrieveSmallPowerSupplyPackage(),
        standardPowerSupply = retrieveStandardPowerSupplyPackage(),
        busExpansion = retrieveBusExpansionPackage(),
        choosenDistributionSystem = BticinoS4B.Instances.Models.ApplicationModel.get('choosenDistributionSystem'),
        packagesToReturn = [],
        regularCalculation = function() {
          if ((totalCurrentConsumption + smallPowerSupply.specialVars.currentConsumption) <= 0) {
            packagesToReturn.push(smallPowerSupply);
            totalCurrentConsumption += smallPowerSupply.specialVars.currentConsumption;
          } else {
            packagesToReturn.push(standardPowerSupply);
            totalCurrentConsumption += standardPowerSupply.specialVars.currentConsumption;
            if (totalCurrentConsumption > 0) {
              while (totalCurrentConsumption > 0) {
                packagesToReturn.push(busExpansion);

                if (Object.prototype.toString.call(busExpansion) === '[object Array]')
                  totalCurrentConsumption += _.reduce(busExpansion, retrievePackageConsumption, 0);
                else
                  totalCurrentConsumption += busExpansion.specialVars.currentConsumption;
              }
            }

          }
        };

      //Mantis => 05102: AUDIOVIDEO - Modifica calcolo automatico alimentatori
      /*if ((totalCurrentConsumption < 600) && (choosenDistributionSystem.specialVars.alternativePowerSupplyCalculation)) {
        if (!choosenDistributionSystem.dontDeliver) {
          choosenDistributionSystem.dontDeliver = true;
          window.BticinoS4B.eventAggregator.trigger("modelDeliver:request");
        }
        packagesToReturn.push(smallPowerSupply);
      } else {*/
        if (totalCurrentConsumption < 1200) { //&& (choosenDistributionSystem.specialVars.alternativePowerSupplyCalculation)) {
          //if (choosenDistributionSystem.dontDeliver) {
            choosenDistributionSystem.dontDeliver = false;
            window.BticinoS4B.eventAggregator.trigger("modelDeliver:request");
          //}
          packagesToReturn.push(standardPowerSupply);
        } else {
          if (choosenDistributionSystem.dontDeliver) {
            choosenDistributionSystem.dontDeliver = false;
            window.BticinoS4B.eventAggregator.trigger("modelDeliver:request");
          }
          regularCalculation();
        }
      //}

      return packagesToReturn;
    };

    CalculationClass.calculateLineTerminators = function() {
      var lineTerminatorPackage,
        lineTerminatorsToAdd = [],
        filterId = BticinoS4B.solution.audioVideo.filterId;

      //Se il sistema di diffusione sonora è inserito
      if (filterId > 2) {
        //Retrieving package data
        BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass("-260", function(data) {
          lineTerminatorPackage = data;
          lineTerminatorPackage.specialVars = JSON.parse(lineTerminatorPackage.specialVars);

          //Retrieving product data
          BticinoS4B.Instances.Models.ApplicationModel.getProducts(data.packageClassId, function(output) {
            var mainProduct = _.filter(output.products, function(iterableProduct) {
                return iterableProduct.mnemonic === 1;
              })[0],
              secondaryProducts = _.filter(output.products, function(iterableProduct) {
                return iterableProduct.mnemonic !== 1;
              });

            _.extend(lineTerminatorPackage, mainProduct);
            lineTerminatorPackage.secondaryProducts = secondaryProducts;
            lineTerminatorPackage.quantity = 1;
          });
        });

        //Recupero il numero di zone
        var zonesItems = _.filter(BticinoS4B.solution.audioVideo.zonesItems, function(iterableZone) {
          return iterableZone.number > 0;
        });

        //Per ogni zona aggiungo un terminatore di linea
        for (var i = zonesItems.length - 1; i >= 0; i--)
          lineTerminatorsToAdd.push(lineTerminatorPackage);
      }

      return lineTerminatorsToAdd;
    };

    CalculationClass.calcuateFloorShunts = function() {
      var floorShuntPackage,
      floorShuntsToAdd = [],
      Handsets         = BticinoS4B.solution.audioVideo.handsets ? BticinoS4B.solution.audioVideo.handsets.get("collection") : undefined, // copiato dalla riga 228
      nrOfHandsets     = Handsets ? Handsets.length : 0,
      HandsetsAlim     = [],
      nrOfHandsetsAlim = 0,
      nrOfBusExpansion = (nrOfHandsets > 0) ? ((nrOfHandsets <= 5) ? 0 : Math.ceil(nrOfHandsets / 5) - 1) : 0, // copiato dalla riga 229
      filterId         = BticinoS4B.solution.audioVideo.filterId,
      numberOfFloorShunts;

      if (nrOfHandsets>0) {
        HandsetsAlim     = _.filter(Handsets.models, function(item) {
                           return item.get("selfRegulated") === true;
                         });
        nrOfHandsetsAlim = HandsetsAlim ? HandsetsAlim.length : 0;
      }
     
      //Se citofonia oppure videocitofonia
      if ((filterId >= 2) && (nrOfHandsetsAlim > 1)){
        //Retrieving package data
        BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass("6494", function(data) {
          floorShuntPackage = data;
          floorShuntPackage.specialVars = JSON.parse(floorShuntPackage.specialVars);

          //Retrieving product data
          BticinoS4B.Instances.Models.ApplicationModel.getProducts(data.packageClassId, function(output) {
            var mainProduct = _.filter(output.products, function(iterableProduct) {
                return iterableProduct.mnemonic === 1;
              })[0],
              secondaryProducts = _.filter(output.products, function(iterableProduct) {
                return iterableProduct.mnemonic !== 1;
              });

            _.extend(floorShuntPackage, mainProduct);
            floorShuntPackage.quantity = 1;
          });
        });

        // math.ceil(( NR posti interni autoalimentati - nr di espansioni tratte montante autocalcolate [346851] - 1) /4)

        numberOfFloorShunts = Math.ceil((nrOfHandsetsAlim - nrOfBusExpansion - 1) / 4);

        for (var i = 0; i < numberOfFloorShunts; i++) {
          floorShuntsToAdd.push(floorShuntPackage);
        }

      }
      
      return floorShuntsToAdd;
    };

    CalculationClass.createConfiguration = function() {

      /*
        ASSEGNAZIONE DELLE ZONE
        
        -305 POSTI ESTERNI
        -304 POSTI INTERNI
        -303 COMANDI E ATTUATORI
        -302 SORGENTI
        -301 ARTICOLI DI SISTEMA
           0 COMANDI PRINCIPALI
           1 -> 8 ZONE 
        ASSEGNAZIONE N

        TUTTI GLI ARTICOLI COLLEGATI NON OCCUPANO LA N MA UTILIZZANO QUELLA DEL PRINCIPALE
        I COMANDI HANNO TUTTI N = 0

      */

      //Counters
      var i, j, l, g, k = 1,
        counter = 0,
        productToAdd, productQuantity, validitiesLength;
      var sobstitutionMatrix = [];
      var dataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider");

      //Submodel
      var externalItems = dataProvider.get("items").externalItems ? dataProvider.get("items").externalItems : null,
        externalItemsLength = externalItems ? externalItems.length : 0;

      var zones = dataProvider.get("items").zonesItems ? dataProvider.get("items").zonesItems : null,
        zonesLength = zones ? zones.length : 0;

      var automaticItems = dataProvider.get("items").automaticItems ? dataProvider.get("items").automaticItems : null,
        automaticItemsLength = automaticItems ? automaticItems.length : 0;

      var optionalPackages = BticinoS4B.solution.audioVideo.optionalPackages,
        optionalPackagesLength = optionalPackages ? optionalPackages.length : 0;

      var plainProducts = [];
      var modelToSend = [];

      //Adding external items to plain products array
      for (i = 0; i < externalItemsLength; i++) {
        productToAdd = _.extend({}, externalItems[i]);
        if (productToAdd.packageClassId !== "2002") {
          productQuantity = productToAdd.quantity;
          productToAdd.zone = -301;
          productToAdd.aux = "";

          for (j = 0; j < productQuantity; j++) {
            productToAdd.newProgNumber = k;
            plainProducts.push(_.extend({
              attachedProducts: []
            }, productToAdd));
            k++;
          }
        }
      }

      //Adding zone items to plain products array
      for (i = 0; i < zonesLength; i++) {
        var zoneLength = zones[i].items.length;

        for (j = 0; j < zoneLength; j++) {
          if (zones[i].items[j].packageClassId) {
            productToAdd = _.extend({}, zones[i].items[j]);
            productQuantity = productToAdd.quantity;
            //delete productToAdd.quantity;

            productToAdd.zone = zones[i].number;
            productToAdd.aux = "";

            for (l = 0; l < productQuantity; l++) {
              productToAdd.newProgNumber = k;
              plainProducts.push(_.extend({
                attachedProducts: []
              }, productToAdd));
              k++;
            }
          }
        }
      }

      //Adding optional items to plain products array
      for (i = 0; i < optionalPackagesLength; i++) {
        var packageToAdd = _.extend({}, optionalPackages[i]);
        var packageProducts = packageToAdd.get("products").packagesByOptionalPackageId;
        var packageProductsLength = packageProducts.length;

        for (l = 0; l < packageProductsLength; l++) {
          productToAdd = _.extend(packageProducts[l]);
          productQuantity = 0;
          var productPackageClassId = "";

          if (productToAdd.attributes) {
            productQuantity = productToAdd.get("value");
            productPackageClassId = productToAdd.get("packageClassId");
          } else {
            productQuantity = productToAdd.value;
            productPackageClassId = productToAdd.packageClassId;
          }
          var zoneValue = -301;

          //Exception for IR interface
          if (productPackageClassId === "2101")
            zoneValue = 99;

          productToAdd = {
            zone: zoneValue,
            aux: "",
            packageClassId: productPackageClassId
          };

          for (j = 0; j < productQuantity; j++) {
            productToAdd.newProgNumber = k;
            plainProducts.push(_.extend({}, productToAdd));
            k++;
          }
        }
      }


      //Adding autocalculated items
      var iterator = function(item) {
        return item.progNumber;
      };
      for (i = 0; i < automaticItemsLength; i++) {
        validitiesLength = automaticItems[i].attachedProducts ? automaticItems[i].attachedProducts.length : 0;
        productToAdd = _.extend({}, automaticItems[i]);
        productQuantity = productToAdd.quantity;
        //delete productToAdd.quantity;

        productToAdd.zone = -301;
        productToAdd.aux = "";

        for (l = 0; l < productQuantity; l++) {
          productToAdd.newProgNumber = k;
          plainProducts.push(_.extend({}, productToAdd));
          k++;
          if (productToAdd.secondaryProducts)
            for (q = 0; q < productToAdd.secondaryProducts.length; q++) {
              productToAdd.secondaryProducts[q].newProgNumber = k;
              plainProducts.push(_.extend({}, productToAdd.secondaryProducts[q]));
              k++;
            }
        }
      }

      //Adding autocalculated items with validities
      for (i = 0; i < plainProducts.length; i++) {
        if (plainProducts[i].attachedProducts) {
          plainProducts[i].slot = [];
          for (j = 0; j < plainProducts[i].attachedProducts.length; j++) {
            plainProducts[i].slot.push({
              idLink: plainProducts[i].attachedProducts[j].progNumber
            });
          }
        }
      }

      /*Assigning values for N on plainProducts*/

      var retrieveGroupId = function(iterableProduct) {
          if (iterableProduct.specialVars) return iterableProduct.specialVars.groupId;
          else return undefined;
        },
        retrieveZone = function(iterableProduct) {
          return (iterableProduct.zone !== undefined && iterableProduct.zone > 0);
        },
        productsInZone = _.filter(plainProducts, retrieveZone),
        productsOffZone = _.difference(plainProducts, productsInZone),
        plainProductsWithGroupIdsOffZone = _.groupBy(productsOffZone, retrieveGroupId),
        plainProductsGroupedByZone = _.groupBy(productsInZone, function(product) {
          if (product.zone > 0) return product.zone;
          else return false;
        }),
        plainProductsInZoneByGroupId = [],
        plainProductsWithGroupIdsOffZoneLength = plainProductsWithGroupIdsOffZone.length,
        plainProductsGroupedByZoneLength = plainProductsGroupedByZone.length,
        nCounter = 1,
        product,
        productsForThisZone,
        prevZoneName,
        zone;

      var finalProductToAdd,
        objectToAdd,
        prod;

      var telephonyProducts = plainProductsWithGroupIdsOffZone[903];

      for (product in plainProductsWithGroupIdsOffZone) {
        plainProductsWithGroupIdsOffZoneLength = plainProductsWithGroupIdsOffZone[product].length;
        nCounter = 1;
        for (j = 0; j < plainProductsWithGroupIdsOffZoneLength; j++) {
          if ((!plainProductsWithGroupIdsOffZone[product][j].validFor) || ((plainProductsWithGroupIdsOffZone[product][j].validFor) && (plainProductsWithGroupIdsOffZone[product][j].validFor.length === 0))) {
            if (plainProductsWithGroupIdsOffZone[product][j].isVde || plainProductsWithGroupIdsOffZone[product][j].isApartmentInterface)
              plainProductsWithGroupIdsOffZone[product][j].N = nCounter - 1;
            else {
              plainProductsWithGroupIdsOffZone[product][j].N = nCounter;
            }
            nCounter++;
          }
        }
      }

      for (product in plainProductsWithGroupIdsOffZone) {
        plainProductsWithGroupIdsOffZoneLength = plainProductsWithGroupIdsOffZone[product].length;

        /*Assigning values for N on attached products*/
        for (i = 0; i < plainProductsWithGroupIdsOffZoneLength; i++) {
          if ((plainProductsWithGroupIdsOffZone[product][i].attachedProducts) && (plainProductsWithGroupIdsOffZone[product][i].attachedProducts.length > 0)) {
            for (j = 0; j < plainProductsWithGroupIdsOffZone[product][i].attachedProducts.length; j++) {
              for (prod in plainProductsWithGroupIdsOffZone) {
                for (l = 0; l < plainProductsWithGroupIdsOffZone[prod].length; l++)
                  if (plainProductsWithGroupIdsOffZone[prod][l].progNumber === plainProductsWithGroupIdsOffZone[product][i].attachedProducts[j].idLink) {
                    plainProductsWithGroupIdsOffZone[product][i].attachedProducts[j].N = plainProductsWithGroupIdsOffZone[prod][l].N;
                    plainProductsWithGroupIdsOffZone[product][i].attachedProducts[j].Z = plainProductsWithGroupIdsOffZone[prod][l].zone;
                    plainProductsWithGroupIdsOffZone[product][i].attachedProducts[j].idLink = plainProductsWithGroupIdsOffZone[prod][l].newProgNumber;
                    break;
                  }
              }
            }
          }
        }

        //TelephonyException
        nCounter = 1;

        if (telephonyProducts) {
          for (j = 0; j < telephonyProducts.length; j++) {
            if (
              (
                (!telephonyProducts[j].validFor) ||
                ((telephonyProducts[j].validFor) && (telephonyProducts[j].validFor.length === 0))
              ) && (!telephonyProducts[j].specialVars.isHandset)
            ) {
              telephonyProducts[j].N = nCounter;
              nCounter++;
            }
          }

          nCounter = 1;
          for (j = 0; j < telephonyProducts.length; j++) {
            if (
              (
                (!telephonyProducts[j].validFor) ||
                ((telephonyProducts[j].validFor) && (telephonyProducts[j].validFor.length === 0))
              ) && (telephonyProducts[j].specialVars.isHandset)
            ) {
              telephonyProducts[j].N = BticinoS4B.solution.audioVideo.telephonyReservedPositions + nCounter;
              nCounter++;
            }
          }
        }

        plainProductsWithGroupIdsOffZone[903] = telephonyProducts;

        for (i = 0; i < plainProductsWithGroupIdsOffZoneLength; i++) {
          if (plainProductsWithGroupIdsOffZone[product][i].packageClassId) {
            objectToAdd = {
              progNumber: plainProductsWithGroupIdsOffZone[product][i].newProgNumber,
              packageClassId: plainProductsWithGroupIdsOffZone[product][i].packageClassId,
              itemcode: plainProductsWithGroupIdsOffZone[product][i].productCode,
              slot: []
            };

            if (plainProductsWithGroupIdsOffZone[product][i].zone !== undefined)
              objectToAdd.Z = plainProductsWithGroupIdsOffZone[product][i].zone;

            if (objectToAdd.Z == -300 ) { objectToAdd.Z = 0}

            if (plainProductsWithGroupIdsOffZone[product][i].N !== undefined)
              objectToAdd.N = plainProductsWithGroupIdsOffZone[product][i].N;

            if (plainProductsWithGroupIdsOffZone[product][i].attachedProducts) {
              for (j = 0; j < plainProductsWithGroupIdsOffZone[product][i].attachedProducts.length; j++) {
                for (l = 0; l < plainProductsWithGroupIdsOffZone[product][i].attachedProducts[j].Slots; l++) {
                  finalProductToAdd = {
                    Z: plainProductsWithGroupIdsOffZone[product][i].attachedProducts[j].Z ? plainProductsWithGroupIdsOffZone[product][i].attachedProducts[j].Z : 0,
                    N: plainProductsWithGroupIdsOffZone[product][i].attachedProducts[j].N ? plainProductsWithGroupIdsOffZone[product][i].attachedProducts[j].N : 0,
                    idLink: plainProductsWithGroupIdsOffZone[product][i].attachedProducts[j].idLink ? plainProductsWithGroupIdsOffZone[product][i].attachedProducts[j].idLink : 0,
                    itemcode: plainProductsWithGroupIdsOffZone[product][i].attachedProducts[j].productCode ? plainProductsWithGroupIdsOffZone[product][i].attachedProducts[j].productCode : 0
                  };

                  objectToAdd.slot.push(_.extend({}, finalProductToAdd));
                }
              }
            }

            modelToSend.push(objectToAdd);
          }
        }
      }

      for (zone in plainProductsGroupedByZone) {
        productsForThisZone = _.groupBy(plainProductsGroupedByZone[zone], retrieveGroupId);

        for (product in productsForThisZone) {
          productsForThisZoneLength = productsForThisZone[product].length;
          nCounter = 1;
          for (j = 0; j < productsForThisZoneLength; j++) {
            if ((!productsForThisZone[product][j].validFor) || ((productsForThisZone[product][j].validFor) && (productsForThisZone[product][j].validFor.length === 0))) {
              if (!productsForThisZone[product][j].isVde)
                productsForThisZone[product][j].N = nCounter;
              else
                productsForThisZone[product][j].N = nCounter - 1;
              nCounter++;
            }
          }
        }

        for (product in productsForThisZone) {
          productsForThisZoneLength = productsForThisZone[product].length;

          /*Assigning values for N on attached products*/
          for (i = 0; i < productsForThisZoneLength; i++) {
            if ((productsForThisZone[product][i].attachedProducts) && (productsForThisZone[product][i].attachedProducts.length > 0)) {
              for (j = 0; j < productsForThisZone[product][i].attachedProducts.length; j++) {
                for (prod in productsForThisZone) {
                  for (l = 0; l < productsForThisZone[prod].length; l++)
                    if (productsForThisZone[prod][l].progNumber === productsForThisZone[product][i].attachedProducts[j].idLink) {
                      productsForThisZone[product][i].attachedProducts[j].N = productsForThisZone[prod][l].N;
                      productsForThisZone[product][i].attachedProducts[j].Z = productsForThisZone[prod][l].zone;
                      productsForThisZone[product][i].attachedProducts[j].idLink = productsForThisZone[prod][l].newProgNumber;
                      break;
                    }
                }
              }
            }
          }

          for (i = 0; i < productsForThisZoneLength; i++) {
            if (productsForThisZone[product][i].packageClassId) {
              objectToAdd = {
                progNumber: productsForThisZone[product][i].newProgNumber,
                packageClassId: productsForThisZone[product][i].packageClassId,
                itemcode: productsForThisZone[product][i].productCode,
                slot: []
              };

              if (productsForThisZone[product][i].zone !== undefined)
                objectToAdd.Z = productsForThisZone[product][i].zone;

              if (productsForThisZone[product][i].N !== undefined)
                objectToAdd.N = productsForThisZone[product][i].N;

              if (productsForThisZone[product][i].attachedProducts) {
                for (j = 0; j < productsForThisZone[product][i].attachedProducts.length; j++) {
                  for (l = 0; l < productsForThisZone[product][i].attachedProducts[j].Slots; l++) {
                    finalProductToAdd = {
                      Z: productsForThisZone[product][i].attachedProducts[j].Z ? productsForThisZone[product][i].attachedProducts[j].Z : 0,
                      N: productsForThisZone[product][i].attachedProducts[j].N ? productsForThisZone[product][i].attachedProducts[j].N : 0,
                      idLink: productsForThisZone[product][i].attachedProducts[j].idLink ? productsForThisZone[product][i].attachedProducts[j].idLink : 0,
                      itemcode: productsForThisZone[product][i].attachedProducts[j].productCode ? productsForThisZone[product][i].attachedProducts[j].productCode : 0
                    };

                    objectToAdd.slot.push(_.extend({}, finalProductToAdd));
                  }
                }
              }

              modelToSend.push(objectToAdd);
            }
          }
        }
      }


      var configuration;
      var getAddedProductDetails = function(packageDetails) {
        configuration.itemsConfiguratorAdded[i] = _.extend(configuration.itemsConfiguratorAdded[i], packageDetails);

        BticinoS4B.Instances.Models.ApplicationModel.getProducts(configuration.itemsConfiguratorAdded[i].packageClassId, function(productDetails) {
          productDetails.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(productDetails.products);
          configuration.itemsConfiguratorAdded[i] = _.extend(configuration.itemsConfiguratorAdded[i], productDetails.products[0]);

          if (configuration.itemsConfiguratorAdded[i].Qta) {
            configuration.itemsConfiguratorAdded[i].quantity = Number(configuration.itemsConfiguratorAdded[i].Qta);
            delete configuration.itemsConfiguratorAdded[i].Qta;
          }
        });

      };
      var getPackageDetails = function(data) {
        configuration = data.d;
        var itemsLength = data.d.items.length;

        for (i = 0; i < itemsLength; i++) {
          configuration.items[i].progNumber = Number(configuration.items[i].progNumber);
        }

        configuration.items = _.sortBy(configuration.items, function(element) {
          return element.progNumber;
        });
        modelToSend = _.sortBy(modelToSend, function(element) {
          return element.progNumber;
        });

        for (i = 0; i < itemsLength; i++) {
          _.extend(modelToSend[i], configuration.items[i]);
        }
        configuration.items = modelToSend;

        var retrievePackageClass = function(counter) {
          if (configuration.items[counter].packageClassId)
            BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(configuration.items[counter].packageClassId, function(result) {
              configuration.items[counter] = _.extend(configuration.items[counter], result);
            });
        };

        for (i = 0; i < itemsLength; i++)
          retrievePackageClass(i);

        if (configuration.itemsConfiguratorAdded)
          for (i = 0; i < configuration.itemsConfiguratorAdded.length; i++)
            BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(configuration.itemsConfiguratorAdded[i].packageClassId, getAddedProductDetails);

        BticinoS4B.Instances.Models.ApplicationModel.set("configurationModel", configuration);
        var configurationModel = BticinoS4B.Instances.Models.ApplicationModel.get("configurationModel").items;
        var configurationModelLength = configurationModel.length;
        var completeConfigurationModel = new Backbone.Model();

        for (i = 0; i < configurationModelLength; i++) {
          if (configurationModel[i].slot) {
            if (configurationModel[i].slot.length > 0) {
              for (j = 0; j < configurationModel[i].slot.length; j++) {
                for (l = 0; l < configurationModel.length; l++) {
                  if (configurationModel[l].progNumber === configurationModel[i].slot[j].idLink) {
                    configurationModel[i].slot[j] = _.extend(configurationModel[i].slot[j], configurationModel[l]);
                    break;
                  }
                }
              }
            }
          }
        }
        var outOfZoneArticles = _.filter(configurationModel, function(element) {
          return (element.Z == -306);
        });
        var zones = _.difference(configurationModel, outOfZoneArticles);
        var zoneNumbers = _.sortBy(_.uniq(_.map(zones, function(element) {
          return element.Z;
        })), function(element) {
          return element;
        });

        var iterator = function(element) {
          return (element.Z === zoneNumbers[i]);
        };

        for (i = 0; i < zoneNumbers.length; i++) {
          zoneNumbers[i] = {
            number: zoneNumbers[i],
            items: _.filter(zones, iterator)
          };
        }
        completeConfigurationModel.set("outOfZoneArticles", outOfZoneArticles);
        completeConfigurationModel.set("zoneArticles", zoneNumbers);

        BticinoS4B.Instances.Models.ApplicationModel.set("getZoneName", function(zoneNumber) {
          var name;
          switch (zoneNumber) {
            case -305:
              name = $.i18n._("IDS_WAV8_5_1"); // POSTI ESTERNI
              break;
            case -304:
              name = $.i18n._("IDS_WAV8_5_2"); // POSTI INTERNI
              break;
            case -303:
              name = $.i18n._("IDS_WAV8_5_3"); // COMANDI E ATTUATORI
              break;
            case -302:
              name = $.i18n._("IDS_WAV8_5_4"); // SORGENTI
              break;
            case -301:
              name = $.i18n._("IDS_W1_9111"); // ARTICOLI DI SISTEMA
              break;
            case -300:
              name = $.i18n._("IDS_WAV8_5_5"); // COMANDI PRINCIPALI
              break;
            case 0:
              name = $.i18n._("IDS_WAV8_5_5"); // COMANDI PRINCIPALI
              break;              
            default:
              name = $.i18n._("IDS_WTR1001_9001") + " " + zoneNumber;
          }

          return name;
        });

        BticinoS4B.solution.audioVideo.completeConfiguration = completeConfigurationModel;
        BticinoS4B.Instances.Models.ApplicationModel.set("completeConfiguration", completeConfigurationModel);
      };

      var lastModelSent = BticinoS4B.solution.audioVideo.lastModelSentToConfigurationService;
      /*
      for (var i = 0; i < modelToSend.length; i++){
        if (modelToSend[i].Z == -300) {modelToSend[i].Z = 0}
      };
      */
      objectToSend = JSON.stringify({
        catalogueId: BticinoS4B.Instances.Models.ApplicationModel.get("catalogId"),
        token: window.BticinoS4B.token,
        items: modelToSend
      });

      if (lastModelSent !== objectToSend) {

        BticinoS4B.Instances.Models.ApplicationModel.set("lastModelSentToConfigurationService", objectToSend);
        $.ajax({
          type: "POST",
          datatype: "json",
          contentType: "application/json",
          async: false,
          url: "/btreport/JSonInterface.asmx/JSonMakeConfiguratorMM",
          data: objectToSend,
          success: function(data) {
            BticinoS4B.Instances.Models.ApplicationModel.set("lastConfiguration", JSON.stringify(data));
            getPackageDetails(data);
          }
        });
      } else
        getPackageDetails(JSON.parse(BticinoS4B.Instances.Models.ApplicationModel.get("lastConfiguration")));

      dataProvider.addItems("configurationItems", BticinoS4B.Instances.Models.ApplicationModel.get("configurationModel").itemsConfiguratorAdded);
    };

    CalculationClass.retrieveModels = function() {
      var currentModel,
        modelToSave = {},
        i = 0,
        j = 0;

      CalculationClass.resetValues();

      //Requesting model delivery
      window.BticinoS4B.eventAggregator.trigger("modelDeliver:request", this);

      /* Setting systemId */
      modelToSave.systemId = '#5+6';
      modelToSave.inserted = BticinoS4B.solution.audioVideo.inserted;
      /*Preparing for saving*/
      modelToSave.accessoryLine = {};

      /*Retrieving accessory line datas*/
      if (BticinoS4B.Instances.Models.ApplicationModel.get("choosenLine")) modelToSave.accessoryLine.line = BticinoS4B.Instances.Models.ApplicationModel.get("choosenLine").id;
      if (BticinoS4B.Instances.Models.ApplicationModel.get("choosenColor")) modelToSave.accessoryLine.color = BticinoS4B.Instances.Models.ApplicationModel.get("choosenColor").id;

      /*Retrieving power supply and system selection datas*/
      if (BticinoS4B.solution.audioVideo.audioVideoSystemSelectionAndPowerSupply) {
        currentModel = BticinoS4B.solution.audioVideo.audioVideoSystemSelectionAndPowerSupply;
        var audioVideoSystemSelectionAndPowerSupply = {
          intercomSystemStatus: currentModel.get("intercomSystemStatus"),
          soundSystemStatus: currentModel.get("soundSystemStatus"),
          type: currentModel.get("powerSupply").get("type") ? currentModel.get("powerSupply").get("type").packageClassId : undefined,
          accessory: currentModel.get("powerSupply").get("accessory") ? currentModel.get("powerSupply").get("accessory").packageClassId : undefined
        };

        if (currentModel.get("powerSupply").get("accessory"))
          currentModel.accessory = currentModel.get("powerSupply").get("accessory").packageClassId;

        modelToSave.audioVideoSystemSelectionAndPowerSupply = audioVideoSystemSelectionAndPowerSupply;
      }

      /*Retrieving bus expansions datas*/
      if (BticinoS4B.solution.audioVideo.busExpansion) {
        modelToSave.busExpansion = {
          collection: []
        };
        currentModel = BticinoS4B.solution.audioVideo.busExpansion.get("collection").models;
        for (i = 0; i < currentModel.length; i++) {
          modelToSave.busExpansion.collection.push({
            type: currentModel[i].get("packageClassId"),
            accessory: currentModel[i].get("accessory") ? {
              packageClassId: currentModel[i].get("accessory").packageClassId
            } : undefined,
            description: currentModel[i].get("description")
          });
        }
      }

      //Sources and externals zone
      modelToSave.externals = {};

      /*Retrieving apartment interface datas*/
      if (BticinoS4B.solution.audioVideo.apartmentInterface) {
        currentModel = BticinoS4B.solution.audioVideo.apartmentInterface;
        modelToSave.externals.apartmentInterfaceModel = {
          value: currentModel.get("value")
        };
      }

      /*Retrieving vdes data*/
      if (BticinoS4B.solution.audioVideo.vdes) {
        modelToSave.externals.vdesModel = {
          collection: []
        };
        currentModel = BticinoS4B.solution.audioVideo.vdes.get("collection").models;
        for (i = 0; i < currentModel.length; i++) {
          modelToSave.externals.vdesModel.collection.push({
            choosenGroup: currentModel[i].get("choosenGroup"),
            packageClassId: currentModel[i].get("packageClassId"),
            accessory: currentModel[i].get("accessory") ? {
              packageClassId: currentModel[i].get("accessory").packageClassId
            } : undefined,
            description: currentModel[i].get("description")
          });
        }
      }

      /*Retrieving vdeExpansions data*/
      if (BticinoS4B.solution.audioVideo.vdeExpansion) {
        modelToSave.externals.vdeExpansionModel = {
          collection: []
        };
        currentModel = BticinoS4B.solution.audioVideo.vdeExpansion.get("collection").models;
        for (i = 0; i < currentModel.length; i++) {
          modelToSave.externals.vdeExpansionModel.collection.push({
            packageClassId: currentModel[i].get("packageClassId"),
            accessory: currentModel[i].get("accessory") ? {
              packageClassId: currentModel[i].get("accessory").packageClassId
            } : undefined,
            description: currentModel[i].get("description")
          });
        }
      }

      //Internals zone
      modelToSave.internals = {};

      /*Retrieving handsets data*/
      if (BticinoS4B.solution.audioVideo.handsets) {
        modelToSave.internals.handsetsModel = {
          collection: []
        };
        currentModel = BticinoS4B.solution.audioVideo.handsets.get("collection").models;
        for (i = 0; i < currentModel.length; i++) {
          modelToSave.internals.handsetsModel.collection.push({
            choosenGroup: currentModel[i].get("choosenGroup"),
            packageClassId: currentModel[i].get("packageClassId"),
            accessory: currentModel[i].get("accessory") ? {
              packageClassId: currentModel[i].get("accessory").packageClassId
            } : undefined,
            description: currentModel[i].get("description")
          });
        }
      }

      /*Retrieving apartment interface datas*/
      if (BticinoS4B.solution.audioVideo.telephony) {
        currentModel = BticinoS4B.solution.audioVideo.telephony;
        if (currentModel.get("enabled")) {
          modelToSave.internals.telephonyModel = {};
          modelToSave.internals.telephonyModel.value = currentModel.get("value");

          if (currentModel.get("accessories")) {
            modelToSave.internals.telephonyModel.accessories = {};

            if (currentModel.get("accessories").urbanLineExpansion)
              modelToSave.internals.telephonyModel.accessories._urbanLineExpansion = {
                value: currentModel.get("accessories").urbanLineExpansion.value
              };

            if (currentModel.get("accessories").urbanLineExpansion)
              modelToSave.internals.telephonyModel.accessories._urbanLineProtection = {
                value: currentModel.get("accessories").urbanLineProtection.value
              };

            if (currentModel.get("accessories").expansion1)
              modelToSave.internals.telephonyModel.accessories._expansion1 = {
                value: currentModel.get("accessories").expansion1.value
              };

            if (currentModel.get("accessories").expansion2)
              modelToSave.internals.telephonyModel.accessories._expansion2 = {
                value: currentModel.get("accessories").expansion2.value
              };

            if (currentModel.get("accessories").powerSupply)
              modelToSave.internals.telephonyModel.accessories._powerSupply = {
                value: {
                  packageClassId: currentModel.get("accessories").powerSupply.value.packageClassId
                }
              };

            if (currentModel.get("accessories").vct) {
              modelToSave.internals.telephonyModel.accessories._vct = {};

              if (currentModel.get("accessories").vct.value.length > 0) {
                modelToSave.internals.telephonyModel.accessories._vct = {
                  packageClassId: currentModel.get("accessories").vct.value[0].packageClassId
                };
                modelToSave.internals.telephonyModel.accessories._vctQuantity = currentModel.get("accessories").vct.value[0].value;
              }

              if (currentModel.get("accessories").vctAccessory.value)
                modelToSave.internals.telephonyModel.accessories._vctAccessory = {
                  packageClassId: currentModel.get("accessories").vctAccessory.value.packageClassId
                };
            }
          }
        }
      }

      //Commands and actuators
      modelToSave.commandsAndActuators = {};

      /*Retrieving vpeDevices datas*/
      if (BticinoS4B.solution.audioVideo.vpeDevices) {
        modelToSave.commandsAndActuators.vpeDevicesModel = {
          collection: []
        };
        currentModel = BticinoS4B.solution.audioVideo.vpeDevices.get("collection").models;
        for (i = 0; i < currentModel.length; i++) {
          modelToSave.commandsAndActuators.vpeDevicesModel.collection.push({
            packageClassId: currentModel[i].get("packageClassId"),
            accessory: currentModel[i].get("accessory") ? {
              packageClassId: currentModel[i].get("accessory").packageClassId
            } : undefined,
            description: currentModel[i].get("description")
          });
        }
      }


      /*Retrieving apartment interface datas*/
      if (BticinoS4B.solution.audioVideo.webServer) {
        currentModel = BticinoS4B.solution.audioVideo.webServer;
        modelToSave.commandsAndActuators.webServerModel = {
          value: currentModel.get("value")
        };
      }

      //Sources zone
      modelToSave.sources = {};

      /*Retrieving sources data*/
      if (BticinoS4B.solution.audioVideo.sources) {
        modelToSave.sources.sourcesModel = {
          collection: []
        };
        currentModel = BticinoS4B.solution.audioVideo.sources.get("collection").models;
        for (i = 0; i < currentModel.length; i++) {
          modelToSave.sources.sourcesModel.collection.push({
            type: currentModel[i].get("packageClassId"),
            accessory: currentModel[i].get("accessory") ? {
              packageClassId: currentModel[i].get("accessory").packageClassId
            } : undefined,
            description: currentModel[i].get("description")
          });
        }
      }

      //Commands zone
      modelToSave.commands = {};

      /*Retrieving touch screen datas*/
      if (BticinoS4B.solution.audioVideo.touchScreen) {
        modelToSave.commands.touchScreenModel = {
          collection: []
        };
        currentModel = BticinoS4B.solution.audioVideo.touchScreen.get("collection").models;
        for (i = 0; i < currentModel.length; i++) {
          modelToSave.commands.touchScreenModel.collection.push({
            packageClassId: currentModel[i].get("packageClassId"),
            accessory: currentModel[i].get("accessory") ? {
              packageClassId: currentModel[i].get("accessory").packageClassId
            } : undefined,
            description: currentModel[i].get("description")
          });
        }
      }

      /*Retrieving touch screen datas*/
      if (BticinoS4B.solution.audioVideo.mainCommand) {
        modelToSave.commands.mainCommandModel = {
          collection: []
        };
        currentModel = BticinoS4B.solution.audioVideo.mainCommand.get("collection").models;
        for (i = 0; i < currentModel.length; i++) {
          modelToSave.commands.mainCommandModel.collection.push({
            packageClassId: currentModel[i].get("packageClassId"),
            accessory: currentModel[i].get("accessory") ? {
              packageClassId: currentModel[i].get("accessory").packageClassId
            } : undefined,
            description: currentModel[i].get("description")
          });
        }
      }

      /*Retrieving amplifier's commands datas*/
      if (BticinoS4B.solution.audioVideo.amplifierCommand) {
        modelToSave.commands.amplifierCommandModel = {
          collection: []
        };
        currentModel = BticinoS4B.solution.audioVideo.amplifierCommand.get("collection").models;
        for (i = 0; i < currentModel.length; i++) {
          modelToSave.commands.amplifierCommandModel.collection.push({
            packageClassId: currentModel[i].get("packageClassId"),
            accessory: currentModel[i].get("accessory") ? {
              packageClassId: currentModel[i].get("accessory").packageClassId
            } : undefined,
            description: currentModel[i].get("description")
          });
        }
      }

      /*Retrieving amplifier's radio commands datas*/
      if (BticinoS4B.solution.audioVideo.amplifierRadioCommand) {
        modelToSave.commands.amplifierRadioCommandModel = {
          collection: []
        };
        currentModel = BticinoS4B.solution.audioVideo.amplifierRadioCommand.get("collection").models;
        for (i = 0; i < currentModel.length; i++) {
          modelToSave.commands.amplifierRadioCommandModel.collection.push({
            packageClassId: currentModel[i].get("packageClassId"),
            accessory: currentModel[i].get("accessory") ? {
              packageClassId: currentModel[i].get("accessory").packageClassId,
              quantity: currentModel[i].get("accessory") ? currentModel[i].get("accessoryValue") : 0
            } : undefined,
            description: currentModel[i].get("description")
          });
        }
      }

      /*Retrieving zones*/
      modelToSave.zones = [];
      var zoneToAdd = {};
      var zonesCollection = [];
      if (BticinoS4B.solution.audioVideo.zones /*.collection*/ ) {
        zonesCollection = BticinoS4B.solution.audioVideo.zones.collection
      };

      _.each(zonesCollection.models, function(zone) {
        zoneToAdd = {};
        zoneToAdd.number = zone.get("number");
        zoneToAdd.name = zone.get("name");
        zoneToAdd.description = zone.get("description");
        zoneToAdd.amplifierAndLoudSpeakersModel = {
          collection: []
        };
        zoneToAdd.amplifierCommandModel = {
          collection: []
        };

        /*Retrieving amplifiers and loudspeakers datas*/
        if (zone.get("amplifierAndLoudSpeakersModel")) {
          currentModel = zone.get("amplifierAndLoudSpeakersModel").get("collection").models;
          for (i = 0; i < currentModel.length; i++) {
            zoneToAdd.amplifierAndLoudSpeakersModel.collection.push({
              packageClassId: currentModel[i].get("packageClassId"),
              accessory: currentModel[i].get("accessory") ? {
                packageClassId: currentModel[i].get("accessory").packageClassId,
                quantity: currentModel[i].get("accessory") ? currentModel[i].get("accessoryValue") : 0
              } : undefined,
              description: currentModel[i].get("description")
            });
          }
        }

        /*Retrieving amplifiers and loudspeakers datas*/
        if (zone.get("amplifierCommandModel")) {
          currentModel = zone.get("amplifierCommandModel").get("collection").models;
          for (i = 0; i < currentModel.length; i++) {
            zoneToAdd.amplifierCommandModel.collection.push({
              packageClassId: currentModel[i].get("packageClassId"),
              accessory: currentModel[i].get("accessory") ? {
                packageClassId: currentModel[i].get("accessory").packageClassId,
                quantity: currentModel[i].get("accessory") ? currentModel[i].get("accessoryValue") : 0
              } : undefined,
              description: currentModel[i].get("description")
            });
          }
        }

        modelToSave.zones.push(zoneToAdd);
      });

      modelToSave.optionals = [];
      if (BticinoS4B.solution.audioVideo.optionalPackages) {
        _.each(BticinoS4B.solution.audioVideo.optionalPackages, function(optionalPackage) {
          _.each(optionalPackage.get("products").packagesByOptionalPackageId, function(optionalProduct) {
            if (optionalProduct.get && optionalProduct.get("value") && (optionalProduct.get("value") > 0)) {
              var optionalToAdd = {};
              optionalToAdd.packageClassId = optionalProduct.get("packageClassId");
              optionalToAdd.value = optionalProduct.get("value");
              modelToSave.optionals.push(optionalToAdd);
            }
          });
        });
      }

      return modelToSave;
    };

    // Required, return the module for AMD compliance
    return CalculationClass;

  });